/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

export const AND = 'and';
export const OR = 'or';
export const EQ = '=';
export const IN = 'in';
export const GTE = '>=';
export const LTE = '<=';
export const GT = '>';
export const LT = '<';
export const STARTS_WITH = 'startswith';
